module.exports = __webpack_public_path__ + "static/the-myth-of-the-rational-voter-16d2791c0bc490bf01a3bb14f9fae006.jpg";